import MobileTimePicker from "./MobileTimePicker"
import DesktopTimePicker from "./DesktopTimePicker"
import { bool } from "prop-types"

const TimePicker = props => {
  const { mobileBrowser } = props
  const PlatformPicker = mobileBrowser ? MobileTimePicker : DesktopTimePicker
  return <PlatformPicker {...props} />
}

TimePicker.propTypes = {
  mobileBrowser: bool.isRequired
}

export default TimePicker
